import { useContext, createContext } from "react"
import { Project as BackendProject } from '@/types/project';

export interface Project extends BackendProject {
  color?: string;
  last_accessed?: string;
}

interface ProjectContextType {
  currentProject: Project | null;
  projects: Project[];
  setCurrentProject: (project: Project) => void;
  updateProject: (project: Project) => void;
  addProject: (project: Project) => void;
  isLoading: boolean;
}

export const ProjectContext = createContext<ProjectContextType | undefined>(undefined);

export const useProject = () => {
  const context = useContext(ProjectContext)
  if (!context) {
    throw new Error("useProject must be used within ProjectProvider")
  }
  return context
}
